import { HttpClient } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { SubSink } from "subsink";
import {
    EmitEvent,
    EventBusService,
} from "../../core/services/event-bus.service";
import { identityFactory } from "../../core/services/identity.service";
import { NbcLoggerService } from "../../shared/logger/nbc-logger.service";
import { BusinessUnitService } from "../../shared/services/business-unit.service";

@Component({
    selector: "business-unit",
    templateUrl: "./business-unit.component.html",
    standalone: false
})
export class BusinessUnitComponent implements OnInit, OnDestroy {
    constructor(
        private _http: HttpClient,
        private businessUnitService: BusinessUnitService,
        private _eventBus: EventBusService,
        private log: NbcLoggerService
    ) {}
    private subs = new SubSink();

    businessUnits: any = [];
    selectedBusinessUnit: any = null;
    departments: any = [];

    getBusinessUnits() {
        this.subs.sink = this.businessUnitService.get().subscribe({
            next: (result) => {
                this.businessUnits = result.reference;
                this.onBusinessUnitSelected(this.businessUnits[0]);
            },
            error: (err) => {
                this.log.showError("Business Units failed to load");
            },
        });
    }

     onBusinessUnitSelected(selectedBu) {
        this.selectedBusinessUnit = selectedBu;
        this._eventBus.emit(
            new EmitEvent(
                "getBusinessUnits",
                "onBusinessUnitsReceived1",
                this.businessUnits
            )
        );

      const useraccess =  identityFactory(
            this._http,
            this.selectedBusinessUnit.id
      )();

      setTimeout(() => {
            this._eventBus.emit(
                new EmitEvent(
                    "onBUClicked",
                    "onBusinessUnitSelected",
                    this.selectedBusinessUnit
                )
            );
        }, 500);
    }

    ngOnInit(): void {
        this.getBusinessUnits();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
